import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.includes";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _name$components$data;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { allProductList, searchProduct, searchProductPro } from "@/api/management/productMapping";
import { search_product_blend } from "@/api/management/productMapping";
import { Loading } from "element-ui";
import { mapState, mapActions } from "vuex";
import { menuAside, menuHeader } from "@/menu";
import latests from "./componetsPage/latests.vue";
import oneHour from "./componetsPage/oneHour.vue";
import comparison from "./componetsPage/comparison.vue";
import rollSuit from "./componetsPage/rollSuit.vue";
import allRechargeP from "./componetsPage/allRechargeP.vue";
import { updateUserState } from "@/api/auth/onlineUser";
import { getInfo } from "@/api/user";
import { useryjenvlist, getHDEnvListByUserID } from "@/api/gmToolNew/gmToolNew";
export default (_name$components$data = {
  name: "index",
  components: {
    latests: latests,
    oneHour: oneHour,
    comparison: comparison,
    rollSuit: rollSuit,
    allRechargeP: allRechargeP
  },
  data: function data() {
    return {
      loading: null,
      featureList: [],
      checkAll: false,
      isIndeterminate: false,
      checkedCities: [],
      ProductList: [],
      activeIndex: "-1",
      isSpecial: false,
      // 项目总览权限控制
      RollSuit: false,
      // 滚服权限控制
      kamitakuItemList: [],
      itemList: [],
      isMobile: false
    };
  },
  created: function created() {
    var _this = this;

    this.$bus.$on("upds", function () {
      _this.functionMenuData();
    });
    this.getsearchProduct();
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  activated: function activated() {
    this.kamitakuItemList = [];
    this.itemList = [];
    this.getsearchProduct();
    this.$refs.comModule0 && this.$refs.comModule0.gettingData(); // this.$refs.comModule1 && this.$refs.comModule1.gettingData();
    // this.$refs.comModule2 && this.$refs.comModule2.gettingData();
    // this.$refs.comModule4 && this.$refs.comModule4.gettingData();
    // this.$refs.comModule5 && this.$refs.comModule5.gettingData();
  },
  watch: {},
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$store.dispatch("d2admin/db/get", {
                dbName: "sys",
                path: "user.isSpecial",
                user: true
              }, {
                root: true
              });

            case 2:
              _this2.isSpecial = _context.sent;

              _this2.severShow();

              _this2.activeIndex = "0";

              _this2.functionMenuData();

              _this2.$bus.$on("updProductS", function () {
                _this2.kamitakuItemList = [];
                _this2.itemList = [];

                _this2.getsearchProduct();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapState("d2admin/serchSelect", ["HomePageState", "searchpkgs", "advchannels", "advLocation", "kamitakuSearchData", "royalpirates"])), mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    },
    is_show_homes: function is_show_homes(state) {
      return state.user.is_show_home;
    },
    game_show_type: function game_show_type(state) {
      return state.user.game_show_type;
    },
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    },
    szgmEnv: function szgmEnv(state) {
      return state.user.useryjenv;
    }
  })),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {// vm.kamitakuItemList = [];
      // vm.itemList = [];
      // vm.getsearchProduct();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    next(this.cancelfimFeature());
  }
}, _defineProperty(_name$components$data, "watch", {}), _defineProperty(_name$components$data, "methods", {
  checkMobile: function checkMobile() {
    this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry|iPad|Windows Phone/i.test(navigator.userAgent) || window.innerWidth <= 768;
  },
  handleResize: function handleResize() {
    this.checkMobile();
  },
  // 服务器展示判断
  severShow: function severShow() {
    var game_mark = this.rawData.game_mark;
    var royalpirates = this.royalpirates,
        severlist = this.severlist;

    if (game_mark.includes(royalpirates)) {
      this.RollSuit = severlist.length > 0;
    } else if (game_mark.includes("yjfm")) {
      this.RollSuit = true;
    }
  },
  // 处理菜单选择事件
  handleSelect: function handleSelect(e) {
    if (!this.szgmEnv.length && this.rawData.game_mark.indexOf('yjfm') > -1 && e == 4) {
      this.$message.error('没有御剑环境权限，请联系管理员');
      return;
    }

    this.activeIndex = e;
  },
  // 获取功能菜单数据
  functionMenuData: function functionMenuData() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var accessMenus;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this3.featureList = _this3.getLocalStorageMenu();
              _context2.next = 3;
              return _this3.getDbData("menu.accessMenus", []);

            case 3:
              accessMenus = _context2.sent;
              _this3.checkedCities = _this3.getSelectedCityIds(accessMenus);

              _this3.updateCheckStatus();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  // 从本地存储获取菜单数据
  getLocalStorageMenu: function getLocalStorageMenu() {
    var menuData = window.localStorage.getItem("Menu");
    return menuData ? JSON.parse(menuData) : [];
  },
  // 获取选中的城市 ID 列表
  getSelectedCityIds: function getSelectedCityIds(accessMenus) {
    var _this4 = this;

    return accessMenus.map(function (item) {
      return _this4.featureList.find(function (i) {
        return i.title === item.title;
      });
    }).filter(function (item) {
      return item;
    }).map(function (item) {
      return item.id;
    });
  },
  // 更新全选和半选状态
  updateCheckStatus: function updateCheckStatus() {
    var checkedCount = this.checkedCities.length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.featureList.length;
    this.checkAll = checkedCount === this.featureList.length;
  },
  // 获取游戏列表
  getsearchProduct: function getsearchProduct() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return search_product_blend();

            case 3:
              res = _context3.sent;

              if (res.code === 200) {
                _this5.itemList = res.data;
              }

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error('获取游戏列表失败:', _context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }))();
  },
  // 功能菜单设置
  confimFeature: function confimFeature() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var selectedFeatures, isLargeScreenData, accessMenus, accessMenusList, settings;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              selectedFeatures = _this6.getSelectedFeatures();

              if (!(selectedFeatures.length === 0)) {
                _context4.next = 4;
                break;
              }

              _this6.$message.error("请选择");

              return _context4.abrupt("return");

            case 4:
              _context4.next = 6;
              return _this6.getDbData("user.islargeScreenData", false);

            case 6:
              isLargeScreenData = _context4.sent;

              _this6.$store.dispatch("d2admin/page/openedLoad");

              _context4.next = 10;
              return _this6.$store.dispatch("d2admin/permission/generateAccessMenus", selectedFeatures);

            case 10:
              accessMenus = _context4.sent;
              accessMenusList = isLargeScreenData ? [{
                path: "/largeScreenData",
                title: "大屏数据",
                icon: "signal"
              }].concat(_toConsumableArray(accessMenus)) : accessMenus;

              _this6.updateMenus(accessMenusList);

              _context4.next = 15;
              return _this6.setDbData("menu.accessMenus", accessMenusList);

            case 15:
              _context4.next = 17;
              return _this6.$store.dispatch("d2admin/page/closeAllt", {}, {
                root: true
              });

            case 17:
              _this6.$store.dispatch("d2admin/serchSelect/setPageStatus", "");

              _context4.next = 20;
              return _this6.getDbData("menu.Settings", "");

            case 20:
              settings = _context4.sent;

              if (!settings) {
                _this6.$store.dispatch("d2admin/serchSelect/setPageStatus", 1);
              }

            case 22:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  // 获取选中的功能菜单列表
  getSelectedFeatures: function getSelectedFeatures() {
    var _this7 = this;

    return this.featureList.filter(function (item) {
      return _this7.checkedCities.includes(item.id);
    });
  },
  // 更新菜单设置
  updateMenus: function updateMenus(accessMenusList) {
    var allMenuHeader = [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenusList));
    var allMenuAside = [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenusList));
    this.$store.commit("d2admin/menu/headerSet", allMenuHeader);
    this.$store.commit("d2admin/menu/asideSet", allMenuAside);
    this.$store.commit("d2admin/search/init", allMenuHeader);
  },
  // 取消功能菜单设置
  cancelfimFeature: function cancelfimFeature() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var accessMenus;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this8.getDbData("menu.accessMenus", []);

            case 2:
              accessMenus = _context5.sent;

              if (!(accessMenus.length === 0)) {
                _context5.next = 5;
                break;
              }

              return _context5.abrupt("return");

            case 5:
              _this8.updateMenus(accessMenus);

              _this8.$store.dispatch("d2admin/serchSelect/setPageStatus", _this8.HomePageState === 2 ? "" : _this8.HomePageState);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  // 处理全选事件
  handleCheckAllChange: function handleCheckAllChange(val) {
    this.checkedCities = val ? this.featureList.map(function (item) {
      return item.id;
    }) : [];
    this.isIndeterminate = false;
  },
  // 处理选中城市变化事件
  handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
    this.checkedCities = value.filter(function (elm) {
      return elm;
    });
    this.updateCheckStatus();
  },
  // 游戏产品设置
  closeItem: function closeItem(items) {
    var _this9 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var loading, query, userInfo, useryjenv, GMauthority, accessMenus;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              console.log("items===", items);
              _context6.next = 3;
              return updateUserState({
                version: process.env.VUE_APP_VERSION_NEW
              });

            case 3:
              loading = _this9.showLoading();
              _context6.next = 6;
              return _this9.$store.dispatch("d2admin/page/closeAllt", {}, {
                root: true
              });

            case 6:
              _this9.resetStoreData();

              _context6.next = 9;
              return _this9.$store.dispatch("d2admin/user/gameShowType", items.game_show_type);

            case 9:
              _context6.next = 11;
              return _this9.$store.dispatch("d2admin/serchSelect/setGame", items);

            case 11:
              query = _context6.sent;
              _context6.next = 14;
              return getInfo();

            case 14:
              userInfo = _context6.sent;
              console.log("items.game_mark.includes('yjfm)", items.game_mark.includes("yjfm"));

              if (!items.game_mark.includes("yjfm")) {
                _context6.next = 25;
                break;
              }

              _context6.next = 19;
              return useryjenvlist({
                user_id: userInfo.data.info.id,
                game_id: _this9.rawData.game_id
              });

            case 19:
              useryjenv = _context6.sent;
              useryjenv.data.map(function (i) {
                i.label = i.name;
                i.value = i.flag;
              });

              _this9.$store.dispatch("d2admin/db/set", {
                dbName: "sys",
                path: "user.useryjenv",
                value: useryjenv.data,
                user: true
              }, {
                root: true
              });

              _this9.$store.dispatch("d2admin/db/set", {
                dbName: "sys",
                path: "user.GMauthority",
                value: [],
                user: true
              }, {
                root: true
              });

              _context6.next = 31;
              break;

            case 25:
              _context6.next = 27;
              return getHDEnvListByUserID({
                user_id: userInfo.data.info.id,
                game_id: _this9.rawData.game_id
              });

            case 27:
              GMauthority = _context6.sent;
              GMauthority.data.map(function (i) {
                i.label = i.name;
                i.value = i.flag;
              });

              _this9.$store.dispatch("d2admin/db/set", {
                dbName: "sys",
                path: "user.GMauthority",
                value: GMauthority.data,
                user: true
              }, {
                root: true
              });

              _this9.$store.dispatch("d2admin/db/set", {
                dbName: "sys",
                path: "user.useryjenv",
                value: [],
                user: true
              }, {
                root: true
              });

            case 31:
              _context6.next = 33;
              return _this9.$store.dispatch("d2admin/user/load", null, {
                root: true
              });

            case 33:
              if (!(query.code === 200)) {
                _context6.next = 43;
                break;
              }

              _context6.next = 36;
              return _this9.setDbData("menu.Settings", true);

            case 36:
              _context6.next = 38;
              return _this9.getDbData("menu.accessMenus", []);

            case 38:
              accessMenus = _context6.sent;

              if (accessMenus.length > 0) {
                _this9.$store.dispatch("d2admin/serchSelect/setPageStatus", "");

                _this9.activeIndex = "0";
              } else {
                _this9.$store.dispatch("d2admin/serchSelect/setPageStatus", 2);
              }

              _this9.severShow();

              _context6.next = 44;
              break;

            case 43:
              _this9.$message({
                type: "error",
                message: "设置失败!"
              });

            case 44:
              _this9.hideLoading(loading);

            case 45:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  // 显示加载提示
  showLoading: function showLoading() {
    return Loading.service({
      lock: true,
      text: "设置中",
      background: "rgba(0, 0, 0, 0.7)"
    });
  },
  // 隐藏加载提示
  hideLoading: function hideLoading(loading) {
    loading.close();
  },
  // 重置 store 数据
  resetStoreData: function resetStoreData() {
    this.$store.commit("d2admin/serchSelect/setreqPayList", false);
    this.$store.commit("d2admin/serchSelect/setreqCurrency", false);
    this.$store.commit("d2admin/serchSelect/setreqCountryList", false);
    this.$store.commit("gmTool/init/set_itemList", []);
    this.$store.commit("gmTool/init/set_isreqItemList", false);
    this.$store.commit("gmTool/init/set_serverList", []);
    this.$store.commit("gmToolYJ/init/set_serverListYJ", []);
  },
  // 取消游戏产品设置
  cancelCloseItem: function cancelCloseItem() {
    this.$store.dispatch("d2admin/serchSelect/setPageStatus", "");
    this.cancelfimFeature();
  },
  // 从数据库获取数据
  getDbData: function getDbData(path, defaultValue) {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", _this10.$store.dispatch("d2admin/db/get", {
                dbName: "sys",
                path: path,
                defaultValue: defaultValue,
                user: true
              }, {
                root: true
              }));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  // 将数据存入数据库
  setDbData: function setDbData(path, value) {
    var _this11 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", _this11.$store.dispatch("d2admin/db/set", {
                dbName: "sys",
                path: path,
                value: value,
                user: true
              }, {
                root: true
              }));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  }
}), _name$components$data);